<main
  class="relative flex h-full min-h-0 flex-1 items-center justify-center overflow-hidden w-full background"
  [class.gap-8]="!fullscreen"
  [class.lg:gap-12]="!fullscreen"
>
  @if (!fullscreen) {
    <section
      class="relative z-30 h-full shrink-0 overflow-visible transition-all duration-300"
      [ngClass]="shortMode() ? 'w-24' : 'w-80'"
    >
      <ng-content select="[menu]" />
    </section>
  }

  <section class="relative z-0 flex flex-col h-full flex-1 overflow-hidden min-w-0">
    <div
      class="flex justify-center flex-1 overflow-y-auto"
      [ngClass]="fullscreen ? '' : 'px-3 pb-3 lg:px-10'"
    >
      <div [ngClass]="fullscreen ? 'w-full' : 'max-w-[1920px] w-full'">
        @if (!fullscreen) {
          <ng-content select="[header]" />
        }
        <ng-content select="router-outlet" />
      </div>
    </div>
  </section>
</main>
